import { render, staticRenderFns } from "./entry.vue?vue&type=template&id=641dea57&"
import script from "./entry.vue?vue&type=script&lang=js&"
export * from "./entry.vue?vue&type=script&lang=js&"
import style0 from "./entry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports